
import { mapActions, mapState } from 'vuex'
import time from '@/components/tools/time'
import auction from '@/components/tools/auction'
import AuctionStatusChip from '@/components/catalog/chips/AuctionStatusChip'
import MyAdItemTrailerChips from '@/components/account/vehicles/MyAdItemTrailerChips'
import MyAdItemMotorhomeChips from '@/components/account/vehicles/MyAdItemMotorhomeChips'
import utils from '@/components/tools/utils'
import ProductListingItemImage from '@/components/catalog/ProductListingItemImage.vue'
import DoYouReallyWant from '@/components/account/messages/DoYouReallyWant.vue'

export default {
  components: {
    DoYouReallyWant,
    ProductListingItemImage,
    MyAdItemMotorhomeChips,
    MyAdItemTrailerChips,
    AuctionStatusChip
  },
  props: {

    maxWidthImageCard: {
      type: Number,
      default: 200
    },
    item: {
      type: Object,
      default: () => {
      }
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  async fetch () {
    await this.$store.dispatch('upload/getAttributesDe')
  },
  computed: {
    ...mapState('customer', ['customer', 'adsPage', 'adsInEditing', 'adsProducts', 'hasCompletedProfileData', 'customerAddress']),
    ...mapState('upload', ['attributesDe']),
    buttonSize () {
      return utils.getButtonSize(this)
    },
    title () {
      if (this.item.title.includes('null')) {
        return this.item.make
      } else {
        return this.item.title
      }
    },
    vatPercentageCustomer () {
      if (this.customerAddress.vatPercentage) {
        return this.customerAddress.vatPercentage
      } else {
        return 19
      }
    },
    highIntentPlannedDateOfSaleOptionIds () {
      return this.attributesDe?.planned_date_of_sale?.options
        .filter(
          option =>
            option?.label.toLowerCase().includes('sofort') ||
            option?.label.toLowerCase().includes('zeitnah') ||
            option?.label.toLowerCase().includes('wochen')
        )
        .map(option => option.optionId)
    }

  },
  methods: {
    ...mapActions('customer', ['getAds']),
    ...mapActions('upload', [
      'getOnboardingStepperData']),
    async deleteAd (entityId) {
      if (this.$auth.loggedIn) {
        await this.$axios.delete(`/private/product/delete/${entityId}`, { withCredentials: true })
        await this.getAds(this.adsPage)
      } else {
        await this.$axios.delete(`/public/product/delete/${entityId}`, { withCredentials: true })
      }
      this.getOnboardingStepperData({})
    },
    endingAt (product) {
      return time.parseDate(product.auction?.endingAt)
    },
    startingAt (product) {
      return time.parseDate(product.auction?.startingAt)
    },
    formatCurrency (value) {
      return utils.formatCurrency(value)
    },

    targetPrice (product) {
      if (product.auction?.targetPrice) {
        return this.formatCurrency(product.auction?.targetPrice)
      } else {
        return '-'
      }
    },
    currentPrice (product) {
      if (product.auction?.currentPrice && (product.auction?.status === 'running' || product.auction?.status === 'sold' || product.auction?.status === 'failed' ||
        product.auction?.status === 'renegotiation')) {
        return product?.auction?.hasBids ? this.formatCurrency(product.auction.currentPrice) : '-'
      } else {
        return '-'
      }
    },

    auctionPriceTitle (product) {
      return auction.auctionPriceTitle(product, true)
    },
    currentPriceColor (product) {
      return utils.currentPriceColor(product)
    },
    vatReportable (product) {
      return product.auction?.vatReportable
    },

    syscaraId (product) {
      if (product.syscaraId) {
        return ` / Syscara Id: ${product.syscaraId}`
      } else {
        return ''
      }
    },
    plannedDateOfSaleAttribute (item) {
      return item.attributes.selects.find(select =>
        select.attributeCode === 'planned_date_of_sale'
      )
    },
    highIntentPlannedDateOfSale (item) {
      return this.highIntentPlannedDateOfSaleOptionIds?.includes(this.plannedDateOfSaleAttribute(item)?.value?.optionId)
    },
    async goToAdOrToPdOrShowDialog (item) {
      const productType = item.productType

      const hasPlannedDateOfSale = item.attributes.selects.find(select =>
        select.attributeCode === 'planned_date_of_sale'
      )?.value

      if (item.auction.status === 'editing') {
        if (!hasPlannedDateOfSale) {
          await this.$router.push(this.localePath({
            name: 'vstepper-id',
            params: { id: item.entityId }
          }))
        } else {
          const step = utils.getStepForAdInEditing(item,
            this.hasCompletedProfileData &&
            (this.customer.phoneNumberVerificationBypassedManually || this.customer.phoneNumberVerified)
            , this.$auth.loggedIn)
          await this.$router.push(this.localePath({
            name: `ad-edit-${productType}-${step}-id`,
            params: { id: item.entityId }
          }))
        }
      } else {
        await this.$router.push(this.localePath({
          name: 'catalog-product-id',
          params: { id: item.entityId }
        }))
      }
    },

    renegotiationActive (product) {
      return product.auction?.status === 'renegotiation'
    },
    status (product) {
      return product.auction?.status
    },
    versionedProductStatus (product) {
      return product.versionedProductStatus
    },

    hasBids (product) {
      return product.auction?.hasBids
    },
    isTrailer (item) {
      return item.productType === 'trailer'
    },
    productTitle (product) {
      if (product.title?.includes('null')) {
        if (product.make) {
          return product.make
        } else if (product.model) {
          return product.model
        } else {
          return this.$t('no_title')
        }
      }
      if (this.$vuetify.breakpoint.mobile) {
        return product.title
      } else if (product.title?.length > 50) {
        return product.title.substring(0, 50) + '...'
      } else {
        return product.title
      }
    }

  }
}
